import { Button, DatePicker, Drawer, Form, Input, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const MerchantSaveFoodPandaTransactionUnsave = ({
  originaTab,
  open,
  close,
  setLoading,
  getFoodPandaUnsaveList,
  getMerchantFoodPandaSaveList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);

  const handleSaveToFoodpandaTrnx = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/foodpanda-report/save/product-unsave", formdata)
      //   merchant/save-delivery-unsave
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Saved to food panda report successfully.");
          setTimeout(() => {
            originaTab();
            close();
            setLoadings(false);
            setLoading(false);
            getFoodPandaUnsaveList();
            getMerchantFoodPandaSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Save Other Transaction"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="save-delivery2"
        initialValues={{ remember: true }}
        onFinish={handleSaveToFoodpandaTrnx}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="transaction_no"
            label="Transaction #"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set transaction #" size="large" />
          </Form.Item>

          <Form.Item
            name="transaction_date"
            label="Transaction Date"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <DatePicker
              format={"MM/DD/YYYY"}
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item
            name="customer_name"
            label="Customer Name"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set customer name" size="large" />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Save"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default MerchantSaveFoodPandaTransactionUnsave;
